import React, { useEffect, useState } from 'react';

interface Config {
  features: {
    darkMode: boolean;
    analytics: boolean;
    notifications: boolean;
  };
  version: string;
}

function Settings() {
  const [config, setConfig] = useState<Config | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/config')
      .then(res => res.json())
      .then(data => {
        setConfig(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch config:', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading settings...</div>;

  return (
    <div className="settings">
      <h2>Settings</h2>
      
      <div style={{ marginTop: '1rem' }}>
        <h3>Features</h3>
        <div style={{ marginTop: '0.5rem' }}>
          <label>
            <input 
              type="checkbox" 
              checked={config?.features.darkMode || false}
              onChange={() => {}}
            />
            Dark Mode
          </label>
        </div>
        <div style={{ marginTop: '0.5rem' }}>
          <label>
            <input 
              type="checkbox" 
              checked={config?.features.analytics || false}
              onChange={() => {}}
            />
            Analytics
          </label>
        </div>
        <div style={{ marginTop: '0.5rem' }}>
          <label>
            <input 
              type="checkbox" 
              checked={config?.features.notifications || false}
              onChange={() => {}}
            />
            Notifications
          </label>
        </div>
      </div>
      
      <div style={{ marginTop: '2rem' }}>
        <p>Version: {config?.version}</p>
      </div>
    </div>
  );
}

export default Settings;